<template>
    <div class="srv-carte-ecran">
        <header class="srv-head">
            <button class="srv-icone-btn" aria-label="Retour" @click="$emit('retour')">
                <i class="ri-arrow-left-line"></i>
            </button>
            <div>
                <div class="srv-head-titre">{{ table ? table.name : 'La carte' }}</div>
                <div class="srv-head-sous srv-num">Total : {{ fmt(total) }}</div>
            </div>
            <!-- Avec / sans images : choix propre à l'appareil. -->
            <button class="srv-icone-btn srv-img-toggle" :class="{ on: avecImages }"
                    :aria-pressed="avecImages ? 'true' : 'false'"
                    :aria-label="avecImages ? 'Masquer les images' : 'Afficher les images'"
                    @click="basculerImages">
                <i :class="avecImages ? 'ri-image-line' : 'ri-image-off-line'"></i>
            </button>
        </header>

        <div class="srv-corps">
            <span class="srv-recherche">
                <i class="ri-search-line"></i>
                <input v-model="q" type="search" placeholder="Rechercher un plat…" />
                <button v-if="q" class="srv-recherche-x" aria-label="Effacer" @click="q = ''">
                    <i class="ri-close-line"></i>
                </button>
            </span>

            <!-- Onglets de section : PLATS, BOISSONS, DESSERTS - l'ordre vient
                 du mapping, on ne sert pas les desserts en premier. -->
            <div class="srv-cats">
                <button v-for="s in sections" :key="s.nom"
                        class="srv-cat" :class="{ active: catActive === s.nom }"
                        @click="allerSection(s.nom)">
                    {{ s.nom }}
                </button>
            </div>

            <div v-if="!sectionsFiltrees.length" class="srv-vide">
                <i class="ri-search-line"></i>
                <p>Aucun plat</p>
                <small>Essayez une autre recherche.</small>
            </div>

            <section v-for="s in sectionsFiltrees" :key="s.nom" :id="'srv-s-' + slug(s.nom)">
                <h2 class="srv-sec-titre">{{ s.nom }}</h2>

                <!-- Lignes denses : ~6 par écran. Le nom à gauche, le prix à
                     droite en chiffres tabulaires pour que la colonne s'aligne.
                     La vignette n'apparaît que si le plat a une photo et que
                     les images sont affichées sur cet appareil. -->
                <button v-for="p in s.items" :key="p.pid" class="srv-plat" @click="$emit('ouvrir-plat', p)">
                    <img v-if="photo(p)" :src="photo(p)" alt="" class="srv-plat-img"
                         loading="lazy" decoding="async" @error="illisibles = illisibles.concat(p.pid)" />
                    <span class="srv-plat-txt">
                        <span class="srv-plat-nom">{{ p.libelle }}</span>
                        <span class="srv-plat-prix srv-num">
                            {{ plusieursTarifs(p) ? 'dès ' + fmt(prixMini(p)) : fmt(prixMini(p)) }}
                        </span>
                        <span v-if="p.accompagnement.length" class="srv-plat-acc">
                            {{ apercuAccomp(p) }}
                        </span>
                    </span>
                    <span class="srv-plat-add">
                        <span v-if="qteDe(p.pid)" class="srv-plat-qte srv-num">{{ qteDe(p.pid) }}</span>
                        <i v-else class="ri-add-line"></i>
                    </span>
                </button>
            </section>
        </div>

        <div class="srv-barre">
            <button class="srv-btn srv-voir" :disabled="!lignes.length" @click="$emit('voir-commande')">
                <span class="srv-voir-g">
                    <span class="srv-voir-lbl">Voir la commande</span>
                    <span class="srv-voir-nb srv-num">{{ nbArticles }} article{{ nbArticles > 1 ? 's' : '' }}</span>
                </span>
                <span class="srv-voir-d srv-num">{{ fmt(total) }}</span>
                <i class="ri-arrow-right-s-line"></i>
            </button>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import { fmt, slug, sansAccent, prixMini, plusieursTarifs } from "../menu/format";
    import { imagesActives, reglerImages, urlPhoto } from "@/service/imagesArticles";

    export default {
        name: "srvlacarte",
        props: {
            carte: { type: Array, default: () => [] },
            table: { type: Object, default: null },
            lignes: { type: Array, default: () => [] },
        },
        emits: ["ouvrir-plat", "voir-commande", "retour"],
        // illisibles : plats dont l'image n'a pas pu être chargée (la ligne reste sans vignette).
        data: () => ({ q: "", catActive: "", avecImages: imagesActives(), illisibles: [] }),
        computed: {
            sections() {
                const map = new Map();
                for (const p of this.carte) {
                    const nom = p.catalogue || "AUTRES";
                    if (!map.has(nom)) map.set(nom, []);
                    map.get(nom).push(p);
                }
                return Array.from(map, ([nom, items]) => ({ nom, items }));
            },
            sectionsFiltrees() {
                const q = sansAccent(this.q.trim());
                if (!q) return this.sections;
                return this.sections
                    .map((s) => ({ nom: s.nom, items: s.items.filter((p) => this.correspond(p, q)) }))
                    .filter((s) => s.items.length);
            },
            nbArticles() { return this.lignes.reduce((s, l) => s + l.qte, 0); },
            total() { return this.lignes.reduce((s, l) => s + l.pu * l.qte, 0); },
            qteParPid() {
                const m = {};
                for (const l of this.lignes) m[l.pid] = (m[l.pid] || 0) + l.qte;
                return m;
            },
        },
        methods: {
            fmt, slug, prixMini, plusieursTarifs,
            photo(p) {
                if (!this.avecImages || this.illisibles.indexOf(p.pid) !== -1) return "";
                return urlPhoto(p.photo);
            },
            basculerImages() { this.avecImages = reglerImages(!this.avecImages); },
            qteDe(pid) { return this.qteParPid[pid] || 0; },
            correspond(p, q) {
                const acc = p.accompagnement.map((a) => a.name).join(" ");
                return sansAccent([p.libelle, p.catalogue, acc].join(" ")).indexOf(q) !== -1;
            },
            /**
             * Aperçu des accompagnements sur la ligne : « Aloco, Frites ou Igname ».
             *
             * Le « ou » final porte toujours sur le DERNIER nom de la liste
             * affichée. Une première version prenait `noms[2]` en dur et
             * produisait « Atieke, Aloco ou undefined » dès qu'un plat n'en
             * proposait que deux.
             */
            apercuAccomp(p) {
                const noms = p.accompagnement.map((a) => a.name);
                if (noms.length <= 1) return noms[0] || "";
                if (noms.length <= 3) {
                    return noms.slice(0, -1).join(", ") + " ou " + noms[noms.length - 1];
                }
                // Au-delà de trois, la ligne déborderait : on compte le reste.
                return noms.slice(0, 2).join(", ") + " ou " + (noms.length - 2) + " autres";
            },
            allerSection(nom) {
                this.catActive = nom;
                const el = document.getElementById("srv-s-" + slug(nom));
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            },
        },
        mounted() {
            if (this.sections.length) this.catActive = this.sections[0].nom;
        },
    };
</script>

<style scoped>
    .srv-carte-ecran { display: flex; flex-direction: column; min-height: 100vh; }

    .srv-recherche {
        display: flex; align-items: center; gap: 10px;
        min-height: var(--srv-tap); padding: 0 14px; margin-bottom: var(--srv-sm);
        background: var(--srv-surface);
        border: 1px solid var(--srv-border-fort); border-radius: var(--srv-r-input);
    }
    .srv-recherche i { font-size: 20px; color: var(--srv-outline); }
    .srv-recherche input {
        flex: 1; min-width: 0; background: none; border: none; outline: none;
        color: var(--srv-on); font-family: inherit; font-size: 16px;
    }
    .srv-recherche input::placeholder { color: var(--srv-outline); }
    .srv-recherche-x { background: none; border: none; color: var(--srv-outline); cursor: pointer; padding: 4px; }

    .srv-cats { display: flex; gap: var(--srv-sm); margin-bottom: var(--srv-md); overflow-x: auto; }
    .srv-cat {
        flex-shrink: 0; min-height: 42px; padding: 0 20px;
        background: var(--srv-surface-high); color: var(--srv-on-variant);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r-chip);
        font-family: inherit; font-size: 14px; font-weight: 700; cursor: pointer;
    }
    .srv-cat.active { background: var(--srv-primary); color: var(--srv-on-primary); border-color: var(--srv-primary); }

    .srv-sec-titre {
        margin: var(--srv-md) 0 var(--srv-sm);
        font-size: 12px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase;
        color: var(--srv-on-variant);
    }

    .srv-plat-img {
        width: 52px; height: 52px; flex-shrink: 0; object-fit: cover;
        border-radius: var(--srv-r-input); background: var(--srv-surface-high);
    }
    .srv-img-toggle { margin-left: auto; }
    .srv-img-toggle.on { color: var(--srv-primary); }

    .srv-plat {
        display: flex; align-items: center; gap: var(--srv-md);
        width: 100%; min-height: 64px; padding: 12px 0;
        background: none; border: none; border-bottom: 1px solid var(--srv-outline-variant);
        color: var(--srv-on); font-family: inherit; text-align: left; cursor: pointer;
    }
    .srv-plat:hover { background: var(--srv-surface-low); }
    .srv-plat-txt { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
    .srv-plat-nom { font-size: 16px; font-weight: 700; }
    .srv-plat-prix { font-size: 14px; color: var(--srv-on-variant); }
    .srv-plat-acc {
        font-size: 12px; color: var(--srv-outline);
        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .srv-plat-add {
        width: var(--srv-tap); height: var(--srv-tap); flex-shrink: 0;
        display: flex; align-items: center; justify-content: center;
        background: var(--srv-surface-high); border-radius: var(--srv-r);
        color: var(--srv-primary); font-size: 22px; font-weight: 800;
    }
    .srv-plat-qte { font-size: 16px; }

    .srv-voir { justify-content: space-between; }
    .srv-voir-g { display: flex; flex-direction: column; align-items: flex-start; }
    .srv-voir-lbl { font-size: 11px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; opacity: .8; }
    .srv-voir-nb { font-size: 15px; font-weight: 800; }
    .srv-voir-d { margin-left: auto; font-size: 17px; font-weight: 800; }
</style>
